import React, { useContext, useEffect, useState } from "react";
import {
  CircularProgress,
  Tooltip,
  Select,
  Typography,
  MenuItem,
  FormControl,
  InputAdornment,
  TextField,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  Paper,
  TablePagination,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Box,
  FormHelperText,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { ContextSession } from "../../../services/ContextSession";
import IconButton from "@mui/material/IconButton";
import CryptoJS from "crypto-js";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import VisibilityIcon from "@mui/icons-material/Visibility";
import InventoryIcon from "@mui/icons-material/Inventory";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import Popover from "@mui/material/Popover";
import SearchIcon from "@mui/icons-material/Search";

import { useNavigate } from "react-router-dom";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#19438C",
    color: "white",
    fontSize: 16,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    borderRight: "none", // Elimina la línea vertical entre columnas
    borderLeft: "none", // Elimina la línea vertical entre columnas
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
  "&:hover": {
    // Agrega estilo al pasar el cursor sobre la fila
    backgroundColor: "#C1C1C1", // Cambia el color de fondo al pasar el cursor
  },
}));

function ListaSolConstanciasEntrega() {
  let sessi = useContext(ContextSession);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [statusFilter, setStatusFilter] = useState("2");
  const [rows, setRows] = useState([]);
  const navigate = useNavigate();
  const [selectedRow, setSelectedRow] = useState(null);
  const [patchLoading, setPatchLoading] = useState(false);

  const [openDialogRecibido, setOpenDialogRecibido] = useState(false);
  const [openSuccessDialogRecibido, setOpenSuccessDialogRecibido] =
    useState(false);

  const [openDialogEntrega, setOpenDialogEntrega] = useState(false);
  const [openSuccessDialogEntrega, setOpenSuccessDialogEntrega] =
    useState(false);

  const [archivoConstanciaDigital, setArchivoConstanciaDigital] =
    useState(null);
  const [archivoComprobante, setArchivoComprobante] = useState(null);

  const estadosConstancia = {
    1: "PENDIENTE",
    2: "PAGADA",
    3: "CANCELADA",
    4: "EMITIDA",
    5: "ANULADA",
  };

  const tiposConstancia = {
    1: "HISTORIAL DE COTIZACIONES",
    2: "RAZONADA",
    3: "SALDOS PROYECTADOS",
    4: "NO TENER PRÉSTAMO ACTIVO",
    5: "TRÁMITE EMBAJADA",
  };

  const [searchDNI, setSearchDNI] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [filterType, setFilterType] = useState("");
  const handleSearchDNIChange = (event) => setSearchDNI(event.target.value);

  const handleFilterClick = (event, type) => {
    setAnchorEl(event.currentTarget);
    setFilterType(type);
  };

  const handleFilterClose = () => {
    setAnchorEl(null);
    setFilterType("");
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  // const dominio = "http://172.20.7.10:8082";
   const dominio = "https://be.injupemp.gob.hn:8443";
 // const dominio = "http://127.0.0.1:8000";

  // 1. Mueve fetchData fuera de useEffect
  const fetchData = async () => {
    setLoading(true);
    try {
      const secretKey =
        "django-insecure-8mo+j636(t*_cj&s&&3$7@*vwsk#yyl0u5fbv-v*^-)e!y&k#8";
      const oficina = sessi.sessionData.oficina;
      const idOficina = String(oficina).trim();
      const queryString = `IdOficina=${idOficina}`;
      // console.log("Oficina: " + oficina);
      const signature = CryptoJS.HmacSHA256(queryString, secretKey).toString(
        CryptoJS.enc.Hex
      );

      //const response = await fetch(`http://172.20.7.10:8082/api/ConstanciaPag/Oficial/Estado/?IdEstado=${statusFilter}&IdUser=${sessi.sessionData.id}`, {
      const response = await fetch(
        `${dominio}/api/ConstanciaPag/Oficina/?IdOficina=${idOficina}`,
        {
          method: "GET",
          headers: {
            "X-Signature": signature,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) throw new Error("Error al obtener los datos");
      const data = await response.json();
      setRows(data);
    } catch (error) {
      setRows([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [statusFilter]);

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const filteredRows = rows.filter((row) => {
    if (searchDNI.trim() !== "") {
      const dniMatch =
        row.DNI_usuario &&
        row.DNI_usuario.toString()
          .toLowerCase()
          .includes(searchDNI.toLowerCase());

      // Si no coincide con el DNI, descarta la fila inmediatamente
      if (!dniMatch) return false;
    }

    if (statusFilter === "2")
      return (
        row.fk_id_estado === 2 &&
        row.enviadaOficina === true &&
        row.oficinaEntregaParticipante === false &&
        row.recepcionOficina === false
      );
    if (statusFilter === "4")
      return (
        row.fk_id_estado === 4 &&
        row.enviadaOficina === true &&
        row.recepcionOficina === true &&
        row.oficinaEntregaParticipante === true
      );
    if (statusFilter === "Entrega")
      return (
        row.fk_id_estado === 2 &&
        row.enviadaOficina === true &&
        row.recepcionOficina === true &&
        row.oficinaEntregaParticipante === false
      );

    return true;
  });

  const handleClick = (id) => {
    sessi.setVariable("IDsolConstancia", id);
    navigate("/PortalDelParticipante/VerSolConstanciaEntrega");
  };

  ////////////////////////////////////////////////////////////////////////////////////// RECIBIDO

  const handleOpenDialogRecibido = (row) => {
    setSelectedRow(row);
    setArchivoConstanciaDigital(null);
    setOpenDialogRecibido(true);
  };

  // 2. PATCH y dialog de SUBSANAR
  const handleAcceptRecibido = async () => {
    if (!selectedRow || !archivoConstanciaDigital) return;
    setPatchLoading(true);
    const username = sessi.sessionData.username;

    try {
      const secretKey =
        "django-insecure-8mo+j636(t*_cj&s&&3$7@*vwsk#yyl0u5fbv-v*^-)e!y&k#8";
      const idSolicitud = selectedRow;
      //console.log(idSolicitud);

      const formData = new FormData();
      formData.append("IdSolicitud", idSolicitud);
      formData.append("Usuario", username);
      formData.append(
        "ConstanciaEscaneadaDigital",
        archivoConstanciaDigital
      );

      const queryString = `IdSolicitud=${idSolicitud}`;
      const signature = CryptoJS.HmacSHA256(queryString, secretKey).toString(
        CryptoJS.enc.Hex
      );

      const url = `${dominio}/api/ConstanciaPag/MarcarRecibida/Oficina/`;

      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          "X-Signature": signature,
        },
        body: formData,
      });

      if (!response.ok) throw new Error("Error al aprobar la solicitud");
      // CIERRA el dialog y muestra el de éxito
      setOpenDialogRecibido(false);
      setOpenSuccessDialogRecibido(true);
      setArchivoConstanciaDigital(null);
    } catch (error) {
      alert("Ocurrió un error al aprobar la solicitud.");
    }
    setPatchLoading(false);
  };

  // 3. Cuando el usuario acepta el dialog de éxito, cierra el dialog y actualiza la tabla
  const handleSuccessDialogRecibidoClose = () => {
    setOpenSuccessDialogRecibido(false);
    setArchivoConstanciaDigital(null);
    fetchData();
    // setObservacion("");
    // setCamposSeleccionados({ copiaDNI: false, copiaConstancia: false });
  };

  // 3. Cuando el usuario acepta el dialog de éxito, cierra el dialog y actualiza la tabla
  const handleCloseDialogRecibido = () => {
    setOpenDialogRecibido(false);
    setArchivoConstanciaDigital(null);
    fetchData();

    // setObservacion("");
    // setCamposSeleccionados({ copiaDNI: false, copiaConstancia: false });

    // setErrorObservacion(false);
    // setErrorDocumentos(false);
  };

  //////////////////////////////////////////////////////////////////////////////////////

  ////////////////////////////////////////////////////////////////////////////////////// ENTREGADA

  const handleOpenDialogEntrega = (row) => {
    setSelectedRow(row);
    setOpenDialogEntrega(true);
  };

  // 2. PATCH y dialog de SUBSANAR
  const handleAcceptEntrega = async () => {
    if (!selectedRow || !archivoComprobante) return;
    setPatchLoading(true);
    const username = sessi.sessionData.username;
    try {
      const secretKey =
        "django-insecure-8mo+j636(t*_cj&s&&3$7@*vwsk#yyl0u5fbv-v*^-)e!y&k#8";
      const idSolicitud = selectedRow;
      // const idUser = sessi.sessionData.id;

      const formData = new FormData();
      // formData.append("Observacion", observacion);
      // formData.append("Campos", camposString);
      formData.append("IdSolicitud", idSolicitud);
      formData.append("Usuario", username);
      formData.append("CopiaComprobanteEntrega", archivoComprobante);

      const queryString = `IdSolicitud=${idSolicitud}`;
      const signature = CryptoJS.HmacSHA256(queryString, secretKey).toString(
        CryptoJS.enc.Hex
      );
      //const url = `http://172.20.7.10:8082/api/ConstanciaPag/Habilitar/Subsanacion/`;
      const url = `${dominio}/api/ConstanciaPag/MarcarEntregada/Oficina/`;

      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          "X-Signature": signature,
        },
        body: formData,
      });

      if (!response.ok) throw new Error("Error al aprobar la solicitud");
      // CIERRA el dialog y muestra el de éxito
      setOpenDialogEntrega(false);
      setOpenSuccessDialogEntrega(true);
      setArchivoComprobante(null);
    } catch (error) {
      alert("Ocurrió un error al aprobar la solicitud.");
    }
    setPatchLoading(false);
  };

  // 3. Cuando el usuario acepta el dialog de éxito, cierra el dialog y actualiza la tabla
  const handleSuccessDialogEntregaClose = () => {
    setOpenSuccessDialogEntrega(false);
    fetchData();
  };

  // 3. Cuando el usuario acepta el dialog de éxito, cierra el dialog y actualiza la tabla
  const handleCloseDialogEntrega = () => {
    setOpenDialogEntrega(false);
    fetchData();
  };

  //////////////////////////////////////////////////////////////////////////////////////

  return (
    <div className="container" style={{ marginTop: 10 }}>
      <>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: 10,
          }}
        >
          <h2>
            <b>Lista de Solicitudes de Constancias</b>
          </h2>
        </div>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            flexWrap: "wrap",
            mb: 2,
            mt: 1,
            justifyContent: "center", // <--- Cambia aquí
          }}
        >
          <FormControl size="small" sx={{ minWidth: 170 }}>
            <FormHelperText>Filtrar Constancias:</FormHelperText>
            <Select
              value={statusFilter}
              onChange={(e) => {
                setStatusFilter(e.target.value);
                setPage(0);
              }}
              displayEmpty
              fullWidth
            >
              <MenuItem value="2">Pendientes de Recibir</MenuItem>{" "}
              <MenuItem value="Entrega">Pendientes de Entregar</MenuItem>{" "}
              <MenuItem value="4">Entregadas</MenuItem>{" "}
            </Select>
          </FormControl>
        </Box>

        <div className="row" style={{ marginTop: "20px" }}>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell>#</StyledTableCell>
                  {/* <StyledTableCell>ID Solicitud</StyledTableCell> */}
                  <StyledTableCell>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <strong>DNI Solicitante</strong>
                      <Tooltip title="Buscar por DNI" arrow>
                        <IconButton
                          onClick={(event) =>
                            handleFilterClick(event, "searchDNI")
                          }
                          color={searchDNI ? "primary" : "default"}
                        >
                          <ManageSearchIcon
                            style={{
                              color: searchDNI ? "#1976d2" : "white",
                            }}
                          />
                        </IconButton>
                      </Tooltip>
                    </div>
                  </StyledTableCell>
                  <StyledTableCell>Nº Recibo</StyledTableCell>
                  <StyledTableCell>Tipo Constancia</StyledTableCell>
                  <StyledTableCell>Monto</StyledTableCell>
                  <StyledTableCell>Fecha Pagada</StyledTableCell>
                  <StyledTableCell>Fecha Registro</StyledTableCell>
                  <StyledTableCell>Detalle Solicitud</StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    Acciones
                  </StyledTableCell>
                </StyledTableRow>
              </TableHead>

              <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleFilterClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "center",
                }}
                sx={{
                  p: 2,
                  "& .MuiTextField-root": {
                    m: 1,
                    width: "250px",
                  },
                }}
              >
                {filterType === "searchDNI" && (
                  <Box sx={{ p: 2 }}>
                    <TextField
                      placeholder="Buscar por DNI"
                      aria-label="Buscar por DNI"
                      value={searchDNI}
                      onChange={handleSearchDNIChange}
                      autoFocus
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                    <Box
                      sx={{
                        mt: 1,
                        display: "flex",
                        justifyContent: "flex-end",
                      }}
                    >
                      <Button
                        size="small"
                        onClick={() => setSearchDNI("")}
                        disabled={!searchDNI}
                      >
                        Limpiar
                      </Button>
                    </Box>
                  </Box>
                )}
              </Popover>

              <TableBody>
                {loading ? (
                  <StyledTableRow>
                    <StyledTableCell colSpan={11} align="center">
                      <CircularProgress size={24} />
                    </StyledTableCell>
                  </StyledTableRow>
                ) : filteredRows && filteredRows.length > 0 ? (
                  filteredRows
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, idx) => (
                      <StyledTableRow key={row.id_solicitud_constancia}>
                        <StyledTableCell>
                          {page * rowsPerPage + idx + 1}
                        </StyledTableCell>
                        <StyledTableCell>{row.DNI_usuario}</StyledTableCell>
                        <StyledTableCell>{row.numero_recibo}</StyledTableCell>
                        <StyledTableCell>
                          {tiposConstancia[row.fk_id_constancia] ||
                            "DESCONOCIDO"}
                        </StyledTableCell>
                        <StyledTableCell>L.{row.monto}</StyledTableCell>
                        <StyledTableCell>
                          {row.fecha_pagada
                            ? row.fecha_pagada.split("T")[0] +
                              " " +
                              row.fecha_pagada.split("T")[1].substring(0, 8)
                            : "-"}
                        </StyledTableCell>
                        <StyledTableCell>
                          {row.fecha_registro
                            ? row.fecha_registro.split("T")[0] +
                              " " +
                              row.fecha_registro.split("T")[1].substring(0, 8)
                            : "-"}
                        </StyledTableCell>
                        <StyledTableCell>
                          {row.detalle_solicitud}
                        </StyledTableCell>
                        <StyledTableCell>
                          <Box display="flex" justifyContent="center">
                            <Tooltip
                              title="Ver Solicitud"
                              arrow
                              placement="left-start"
                            >
                              <IconButton
                                onClick={() =>
                                  handleClick(row.id_solicitud_constancia)
                                }
                              >
                                <VisibilityIcon
                                  sx={{ color: "green", fontSize: 30 }}
                                />
                              </IconButton>
                            </Tooltip>

                            <Tooltip
                              title="Marcar como Recibida"
                              arrow
                              placement="left-start"
                            >
                              <IconButton
                                onClick={() =>
                                  handleOpenDialogRecibido(
                                    row.id_solicitud_constancia
                                  )
                                }
                                disabled={
                                  patchLoading || //row.fk_id_estado === 4 &&
                                  //   row.oficinaEntregaParticipante === true &&
                                  row.recepcionOficina === true
                                }
                              >
                                <AssignmentTurnedInIcon
                                  sx={{
                                    color:
                                      row.fk_id_estado === 2 &&
                                      row.enviadaOficina === true &&
                                      row.recepcionOficina === false &&
                                      row.oficinaEntregaParticipante === false
                                        ? "green"
                                        : "grey",
                                    fontSize: 30,
                                  }}
                                />
                              </IconButton>
                            </Tooltip>

                            <Tooltip
                              title="Entregar Constancia"
                              arrow
                              placement="left-start"
                            >
                              <IconButton
                                onClick={() =>
                                  handleOpenDialogEntrega(
                                    row.id_solicitud_constancia
                                  )
                                }
                                disabled={
                                  patchLoading ||
                                  row.recepcionOficina === false ||
                                  row.oficinaEntregaParticipante === true
                                }
                              >
                                <ExitToAppIcon
                                  sx={{
                                    color:
                                      row.fk_id_estado === 2 &&
                                      row.enviadaOficina === true &&
                                      row.recepcionOficina === true &&
                                      row.oficinaEntregaParticipante === false
                                        ? "green"
                                        : "grey",
                                    fontSize: 30,
                                  }}
                                />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        </StyledTableCell>
                      </StyledTableRow>
                    ))
                ) : (
                  <StyledTableRow>
                    <StyledTableCell colSpan={11} align="center">
                      No hay datos.
                    </StyledTableCell>
                  </StyledTableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={filteredRows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            labelRowsPerPage={"Filas por página"}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>

        {/* DIALOG PARA RECIBIDO*/}
        <Dialog
          open={openDialogRecibido}
          onClose={handleCloseDialogRecibido}
        >
          <DialogTitle textAlign={"center"}>
            Confirmación de recepción
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              ¿Está seguro que desea <b>confirmar la recepción</b> de la
              constancia?
              {/* <b>
                {selectedRow && tiposConstancia[selectedRow.fk_id_constancia]}{" "}
              </b> */}
              {/* con N° de recibo <b>{selectedRow && selectedRow.numero_recibo}</b>{" "} */}
              {/* del solicitante{" "} */}
              {/* <b>{selectedRow && selectedRow.NombreCompleto_usuario}</b>? */}
            </DialogContentText>
            <input
              accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
              style={{ display: "none" }}
              id="constancia-digital-recibida"
              type="file"
              onChange={(e) => setArchivoConstanciaDigital(e.target.files[0])}
            />
            <label htmlFor="constancia-digital-recibida">
              <Button
                variant="outlined"
                component="span"
                fullWidth
                sx={{ mt: 2 }}
              >
                Adjuntar Constancia Digital
              </Button>
            </label>

            {archivoConstanciaDigital && (
              <Typography
                variant="body2"
                sx={{ mt: 1, color: "text.secondary" }}
              >
                Archivo seleccionado: {archivoConstanciaDigital.name}
              </Typography>
            )}
            {/* <TextField
              multiline
              rows={4}
              autoFocus
              margin="dense"
              label="Observación"
              type="text"
              fullWidth
              variant="outlined"
              value={observacion} // Estado para almacenar la observación
              onChange={(e) => setObservacion(e.target.value)}
              error={!observacion}
              helperText={!observacion ? "La observación es obligatoria" : ""}
              required // Hacer obligatorio
            /> */}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleCloseDialogRecibido}
              color="error"
              disabled={patchLoading}
            >
              No
            </Button>
            <Button
              onClick={handleAcceptRecibido}
              color="primary"
              variant="contained"
              disabled={!archivoConstanciaDigital || patchLoading}
            >
              {patchLoading ? <CircularProgress size={18} /> : "Sí"}
            </Button>
          </DialogActions>
        </Dialog>

        {/* DIALOG DE ÉXITO */}
        <Dialog
          open={openSuccessDialogRecibido}
          onClose={handleSuccessDialogRecibidoClose}
        >
          <DialogTitle>
            <Box display="flex" alignItems="center" justifyContent="center">
              <span style={{ fontWeight: 500 }}>Solicitud Recibida</span>
              <CheckCircleIcon style={{ color: "green", marginLeft: 10 }} />
            </Box>
          </DialogTitle>
          <DialogContent>
            <DialogContentText textAlign={"justify"}>
              La solicitud de constancia fue marcada como recibida con éxito.
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ justifyContent: "center" }}>
            <Button
              onClick={handleSuccessDialogRecibidoClose}
              color="primary"
              variant="contained"
              sx={{ mx: "auto", minWidth: 120 }}
            >
              Aceptar
            </Button>
          </DialogActions>
        </Dialog>

        {/* DIALOG PARA ENTREGADO*/}
        <Dialog
          open={openDialogEntrega}
          onClose={() => setOpenDialogEntrega(false)}
        >
          <DialogTitle textAlign={"center"}>Entregar Constancia</DialogTitle>
          <DialogContent>
            <DialogContentText>
              ¿Está seguro que desea <b>confirmar la entrega</b> de la
              constancia?
            </DialogContentText>

            {/* Input para adjuntar archivo */}
            <input
              accept=".pdf,.jpg,.jpeg,.png,.doc,.docx" // Tipos de archivo permitidos
              style={{ display: "none" }}
              id="comprobante-entrega"
              type="file"
              onChange={(e) => setArchivoComprobante(e.target.files[0])}
            />
            <label htmlFor="comprobante-entrega">
              <Button
                variant="outlined"
                component="span"
                fullWidth
                sx={{ mt: 2 }}
              >
                Adjuntar Comprobante de Entrega
              </Button>
            </label>

            {/* Mostrar nombre del archivo seleccionado */}
            {archivoComprobante && (
              <Typography
                variant="body2"
                sx={{ mt: 1, color: "text.secondary" }}
              >
                Archivo seleccionado: {archivoComprobante.name}
              </Typography>
            )}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setOpenDialogEntrega(false);
                setArchivoComprobante(null); // Limpiar archivo al cancelar
              }}
              color="error"
              disabled={patchLoading}
            >
              No
            </Button>
            <Button
              onClick={handleAcceptEntrega}
              color="primary"
              variant="contained"
              disabled={!archivoComprobante || patchLoading} // Deshabilitar si no hay archivo
            >
              {patchLoading ? <CircularProgress size={18} /> : "Sí"}
            </Button>
          </DialogActions>
        </Dialog>

        {/* DIALOG DE ÉXITO */}
        <Dialog
          open={openSuccessDialogEntrega}
          onClose={handleSuccessDialogEntregaClose}
        >
          <DialogTitle>
            <Box display="flex" alignItems="center" justifyContent="center">
              <span style={{ fontWeight: 500 }}>Solicitud Entrega</span>
              <CheckCircleIcon style={{ color: "green", marginLeft: 10 }} />
            </Box>
          </DialogTitle>
          <DialogContent>
            <DialogContentText textAlign={"justify"}>
              La solicitud de constancia fue marcada como entregada con éxito.
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ justifyContent: "center" }}>
            <Button
              onClick={handleSuccessDialogEntregaClose}
              color="primary"
              variant="contained"
              sx={{ mx: "auto", minWidth: 120 }}
            >
              Aceptar
            </Button>
          </DialogActions>
        </Dialog>
      </>
    </div>
  );
}

export default ListaSolConstanciasEntrega;
